module.exports = __webpack_public_path__ + "img/1-0.6894f350.png";